import * as React from "react";
import { useMemo } from "react";
import { CalcRequestValue } from "../../../../../application/domain/payment/calc-request";
import { PaymentConst } from "@graffer-inc/cloud-gov-core";

import { WarningBanner } from "@graffer-inc/console-design-kit";
type RequestPaymentWarningMessagesProps = {
  calcRequest: CalcRequestValue;
  paymentAmount: number | undefined;
};

export const RequestPaymentWarningMessages: React.FC<
  RequestPaymentWarningMessagesProps
> = ({ calcRequest, paymentAmount }) => {
  // 支払い手段にペイジーが含まれる
  const isAcceptPayeasy = useMemo(() => {
    return calcRequest.getValue().acceptedPaymentMethods.includes("payeasy");
  }, [calcRequest]);

  // ペイジー支払いでATMの利用可能額超過
  const isATMLimitExceeded = useMemo(() => {
    if (!isAcceptPayeasy || paymentAmount === undefined) return false;
    return PaymentConst.PAYEASY_PAYMENT_BY_ATM_MAX_AMOUNT < paymentAmount;
  }, [paymentAmount, isAcceptPayeasy]);

  // ペイジー支払いでATM(現金)の利用可能額超過
  const isATMCashLimitExceeded = useMemo(() => {
    if (!isAcceptPayeasy || isATMLimitExceeded || paymentAmount === undefined)
      return false;

    return PaymentConst.PAYEASY_PAYMENT_BY_ATM_CASH_MAX_AMOUNT < paymentAmount;
  }, [paymentAmount, isAcceptPayeasy, isATMLimitExceeded]);

  return (
    <>
      {isATMLimitExceeded && (
        <div className="mb-2">
          <WarningBanner
            message="ペイジー支払いのATM利用可能金額を超えています。"
            description="ペイジー支払いの場合、インターネットバンキングから支払い頂くよう「申請者へのメッセージ」欄から案内してください。"
          />
        </div>
      )}
      {isATMCashLimitExceeded && (
        <div className="mb-2">
          <WarningBanner
            message="ペイジー支払いのATM(現金)利用可能金額を超えています。"
            description="ペイジー支払いの場合、インターネットバンキング、またはATMのキャッシュカードから支払い頂くよう「申請者へのメッセージ」欄から案内してください。"
          />
        </div>
      )}
      {isAcceptPayeasy && (
        <div className="mb-2">
          <WarningBanner
            message="ペイジー支払いはシステム上で返金することができません。"
            description="返金する場合は申請者と連絡をとり、システム外での返金をしてください。"
          />
        </div>
      )}
    </>
  );
};
